require('./wizardProgressIndicatorResponsive.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const classnames = require('classnames');

class WizardProgressIndicatorResponsive extends React.Component {
    constructor(props) {
        super(props);

        this.buildProgressIndicator = this.buildProgressIndicator.bind(this);
    }

    buildProgressIndicator() {
        const { immSteps, visibleStep } = this.props;

        return immSteps.map((step, index) => {
            const itemIndex = index + 1;
            const isVisibleStep = itemIndex === visibleStep;
            const isLastStep = itemIndex === immSteps.size;
            const progressItemClassName = classnames(
                'wizard-progress-indicator-responsive__item',
                {
                    'wizard-progress-indicator-responsive__item--active': isVisibleStep,
                    'wizard-progress-indicator-responsive__item--valid': itemIndex < visibleStep && !!step.get('valid')
                }
            );
            return (
                <React.Fragment key={index}>
                    {isVisibleStep && (
                        <div className={progressItemClassName}>
                            {itemIndex}
                        </div>
                    )}
                    {itemIndex === visibleStep + 1 && (
                        <div className="wizard-progress-indicator-responsive__text">
                            de
                        </div>
                    )}
                    {isLastStep && (
                        <div className={progressItemClassName}>
                            {itemIndex}
                        </div>
                    )}
                </React.Fragment>
            );
        });
    }
    render() {
        const progressIndicator = this.buildProgressIndicator();
        return (
            <header className="wizard-progress-indicator-responsive">
                <div className='wizard-progress-indicator-responsive__responsive'>
                    <h2>{this.props.finalTitle}</h2>
                    <div className='wizard-progress-indicator-responsive__container-item'  >
                        {progressIndicator}
                    </div>
                </div>
            </header>
        )
    }
}

WizardProgressIndicatorResponsive.propTypes = {
    visibleStep: PropTypes.number.isRequired,
    stepsAmount: PropTypes.number.isRequired,
    immSteps: PropTypes.object.isRequired
};

module.exports = WizardProgressIndicatorResponsive;
